import styled from 'styled-components';
import { colorTheme } from '@styles/muiTheme';

export const SectionHeader = styled.div<{ justify?: string }>`
  display: flex;
  gap: 40px;
  align-items: center;
  justify-content: ${ ({ justify }) => justify || 'space-between' };
`;

export const PhoenixGridHeaderFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const GeneralFormFooter = styled.div`
  background: ${colorTheme.palette.orange[50]};
  border-radius: 8px;
  padding: 24px 32px 40px;
  margin-bottom: 30px;
`;